// client/src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-day-picker/style.css";

import App from "./App";
import AppRootErrorBoundary from "./components/AppRootErrorBoundary";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Tell Sentry which requests to trace — matches your API domain
  tracePropagationTargets: ["localhost", /^https:\/\/api\.landivo\.com/],
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppRootErrorBoundary>
      <App />
    </AppRootErrorBoundary>
  </React.StrictMode>
);
